export function checkNodeValid(node) {
  if (node && node.type !== "obstacle" && !node.isVisited) return true;
  return false;
}

export function getNodesInShortestPathOrder(finishNode) {
  if (finishNode.parentNode === null) return []; //no parents therefore no path
  const nodesInShortestPathOrder = [];
  let pathNode = finishNode.parentNode;
  while (pathNode.parentNode) {
    nodesInShortestPathOrder.unshift(pathNode);
    pathNode = pathNode.parentNode;
  }
  return nodesInShortestPathOrder;
}

export function getNeighbourNodes(grid, node, includeDiag = false) {
  const row = node.row;
  const col = node.col;
  // define directions as arrays [row, col, extraCost]
  const directions = [
    [row - 1, col, 1], // up
    [row, col + 1, 1], // right
    [row + 1, col, 1], // down
    [row, col - 1, 1], // left
  ];

  if (includeDiag === true) {
    directions.push([row - 1, col + 1, Math.SQRT2]); // up-right
    directions.push([row + 1, col + 1, Math.SQRT2]); // down-right
    directions.push([row + 1, col - 1, Math.SQRT2]); // down-left
    directions.push([row - 1, col - 1, Math.SQRT2]); // up-left
  }

  const neighbours = [];
  for (let dir of directions) {
    if (isNodeInGrid(grid, dir[0], dir[1])) {
      neighbours.push({ node: grid[dir[0]][dir[1]], extraDist: dir[2] });
    } else {
      // neighbours.push({ node: null }); // TODO: hmm
    }
  }
  return neighbours;
}

export function getNeighbourNodesDiag(grid, node) {
  return getNeighbourNodes(grid, node, true);
}

export function isNodeInGrid(grid, row, col) {
  // ensure the row exists in the grid, then the column
  if (grid[row] && grid[row][col]) return true;
  return false;
}

export function euclideanDistance(startNode, finishNode) {
  return Math.sqrt(
    (finishNode.row - startNode.row) ** 2 +
      (finishNode.col - startNode.col) ** 2
  );
}

export function manhattanDistance(startNode, finishNode) {
  return (
    Math.abs(finishNode.row - startNode.row) +
    Math.abs(finishNode.col - startNode.col)
  );
}

export function chebyshevDistance(startNode, finishNode, diagCost = 1) {
  // essentially manhattan distance but take into account
  // steps saved by taking diagonal
  const dx = Math.abs(finishNode.col - startNode.col);
  const dy = Math.abs(finishNode.row - startNode.row);
  const stepsSaved = (2 - diagCost) * Math.min(dx, dy);
  return dx + dy - stepsSaved;
}

export function octileDistance(startNode, finishNode) {
  return chebyshevDistance(startNode, finishNode, Math.SQRT2);
}

export function resetGridVisited(grid) {
  for (let row of grid) {
    for (let node of row) {
      node.isVisited = false;
      node.parentNode = null;
      node.distance = Infinity;
    }
  }
}
